'use client';

import { ChatMessage } from '@chewy/chat-library-common';
import { formatTimeWithLowercaseAMPM } from '@chewy/chat-library-common/tools/dates';
import styles from './ChatEndedIndicator.module.scss';
import { useConversation } from '@chewy/chat-library-common';
import { useEffect, useMemo, useRef } from 'react';

export interface ChatEndedIndicatorProps {
  /** The message from structured message */
  message?: ChatMessage;
}

export default function ChatEndedIndicator({ message }: ChatEndedIndicatorProps) {
  const timestamp = useMemo(() => message?.responseTimestamp ?? '', [message]);
  const formattedTime = useMemo(() => formatTimeWithLowercaseAMPM(timestamp), [timestamp]);
  const { requestScroll } = useConversation();
  const containerRef = useRef<HTMLDivElement>(null);

  // Scroll Chat Ended message to top when it appears
  useEffect(() => {
    if (requestScroll && containerRef.current) {
      requestScroll({
        element: containerRef.current,
        timestamp,
      });
    }
  }, [requestScroll, timestamp]);

  return (
    <div ref={containerRef} className={styles.container}>
      <span className={styles.text}>Chat ended at {formattedTime}</span>
    </div>
  );
}
